var Job = /** @class */ (function () {
    function Job() {
        this.id = null;
        this.title = '';
        this.company = null;
        this.clientorbu = null;
        this.requistionNumber = null;
        this.openings;
        this.jobType = null;
        this.jobSalary = null;
        this.transactionId = null;
        this.sponsorships = [];
        this.recruiters = [];
        // preferences
        this.score = null;
        this.techAssessmentId = null;
        this.techAssessmentScore = null;
        this.techAssessment = false;
        this.valueAssessmentId = null;
        this.valueAssessment = false;
        this.eduVerification = null;
        this.expVeification = null;
        this.phoneScreen = null;
        this.interview = null;
        this.licensePreferences = {
            fourDotFiveIntelligence: true,
            techAssessment: false,
            valueAssessment: false,
            educationVerification: false,
            experienceVerification: false,
            phoneScreen: false,
            interview: false,
            imageProctoring: false,
            jobBoardCredentialList: []
        };
        this.daxtraParameters = null;
        this.advancedParametersImage = null;
        this.workflowStepsOrder = null;
        this.profileCriteriaInfo = {
            benefitsNote: "",
            futureMatchesOnly: false,
            certifications: [],
            educations: [],
            experiences: [],
            technicalSkills: [],
            operationalSkills: [],
            otherSkills: [],
            softSkills: [],
        };
    }
    return Job;
}());
export { Job };
//# sourceMappingURL=job.js.map